import { colors, Icon, IconButton, Tooltip } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { formatDateEndOfDay } from "helpers/formatDate";
import { IListInscricoesActive, IListInscrito } from "interfaces/inscricoes";
import ModalEditInscricao from "./ModalEditInscricao";
import { useState } from "react";
import { cpfApplyMask, formatCurrency } from "helpers/utils";

interface Props {
  data: IListInscricoesActive;
  isloading: boolean;
  handleUpdate: () => void;
}
export default function TableAtletasInscrito({
  data,
  isloading,
  handleUpdate,
}: Props) {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [selectedInscricao, setSelectedInscricao] =
    useState<IListInscrito | null>(null);
  const [inscritos, setInscritos] = useState<any>(data?.inscritos);

  const taxaInscricao = Number(data.taxa);
  const inscricaoId = data?.id;
  const evento = data?.evento;

  const handleCloseModal = () => {
    setOpenModal((prevOpen) => !prevOpen);
    setSelectedInscricao(null);
  };

  const handleUpdateInscricao = (inscUpdate: any) => {
    const listUpdateInsc = inscritos.map((insc: any) => {
      if (insc.id === inscUpdate.id) {
        return {
          ...insc,
          categoria: { ...insc, ...inscUpdate.categoria },
          tamanhoCamiseta: inscUpdate.tamanhoCamiseta,
        };
      }
      return insc;
    });
    setInscritos(listUpdateInsc);
    handleUpdate();
    handleCloseModal();
  };

  // Selecionar inscrição
  const handleSelectedInscricao = (inscricao: IListInscrito) => {
    setSelectedInscricao(inscricao);
    setOpenModal((prevOpen) => !prevOpen);
  };

  // Data columns
  const columns: GridColDef<IListInscrito>[] = [
    {
      field: "id",
      headerName: "#",
      align: "center",
      headerAlign: "center",
      width: 60,
      renderCell(params) {
        return (
          <MDBox display="flex" flexDirection="column">
            <IconButton onClick={() => handleSelectedInscricao(params.row)}>
              <Icon>edit</Icon>
            </IconButton>
          </MDBox>
        );
      },
    },
    {
      field: "cpf",
      headerName: "CPF",
      width: 150,
      renderCell(params) {
        return (
          <MDBox display="flex" flexDirection="column">
            <MDTypography variant="body2">
              {cpfApplyMask(params.row.atleta.cpf)}
            </MDTypography>
          </MDBox>
        );
      },
    },
    {
      field: "atleta",
      headerName: "Atleta",
      width: 300,
      renderCell(params) {
        return (
          <MDTypography variant="body2" sx={{ color: colors.blue[500] }}>
            {params.row.atleta.nome.toUpperCase()}
          </MDTypography>
        );
      },
    },
    {
      field: "categoria",
      headerName: "Categoria",
      width: 150,
      renderCell(params) {
        return (
          <MDBox display="flex" flexDirection="column">
            <MDTypography variant="body2">
              {params.row.categoria.descricao}
            </MDTypography>
            <MDTypography variant="caption">
              {params.row.categoria.distancia.descricao}
            </MDTypography>
          </MDBox>
        );
      },
    },
    {
      field: "dataNascimento",
      headerName: "Dt. Nasc.",
      width: 130,
      renderCell(params) {
        return (
          <MDBox display="flex" flexDirection="column">
            <MDTypography variant="body2">
              {formatDateEndOfDay(
                params.row.atleta.dataNascimento,
                "dd/MM/yyyy"
              )}
            </MDTypography>
          </MDBox>
        );
      },
    },
    {
      field: "sexo",
      headerName: "Sexo",
      width: 100,
      renderCell(params) {
        return (
          <MDBox display="flex" flexDirection="column">
            <MDTypography variant="body2">
              {params.row.atleta.sexo.tipo}
            </MDTypography>
          </MDBox>
        );
      },
    },
    {
      field: "tamCamiseta",
      headerName: "Tam. Camiseta",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell(params) {
        return (
          <MDBox display="flex" flexDirection="column">
            <MDTypography variant="body2">
              {params.row.tamanhoCamiseta || "-"}
            </MDTypography>
          </MDBox>
        );
      },
    },
    {
      field: "totalInscricao",
      headerName: "T. Insc.",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell(params) {
        const valorInscricao =
          Number(params.row.valorInscricao) -
          Number(params.row.valorDesconto) +
          taxaInscricao;
        return (
          <MDBox display="flex" flexDirection="column">
            <MDTypography variant="body2">
              {formatCurrency(valorInscricao)}
            </MDTypography>
          </MDBox>
        );
      },
    },
  ];

  return (
    <MDBox>
      <DataGrid
        getRowId={(row) => row.atleta.cpf}
        rows={inscritos}
        columns={columns}
        loading={isloading}
        density="comfortable"
        pageSizeOptions={[20, 50, 100]}
        disableRowSelectionOnClick
        columnHeaderHeight={50}
        sx={{
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.grey[300],
          },
        }}
      />
      {selectedInscricao && (
        <ModalEditInscricao
          update={handleUpdateInscricao}
          inscricao={selectedInscricao}
          inscricaoId={inscricaoId}
          evento={evento}
          open={openModal}
          handleOpen={handleCloseModal}
        />
      )}
    </MDBox>
  );
}
